import request from '@/utils/request'

export class BaseClient {
  protected path: string
  constructor(
    path: string
  ) {
    this.path = path
  }

  async get(id: number): Promise<any> {
    return request({
      url: `/${this.path}/${id}`,
      method: 'get'
    })
  }

  async fetch(params: any): Promise<any> {
    return request({
      url: `/${this.path}`,
      method: 'get',
      params
    })
  }

  async count(params: any): Promise<any> {
    return request({
      url: `/${this.path}/count`,
      method: 'get',
      params: params
    })
  }

  async create(data: any): Promise<any> {
    return request({
      url: `/${this.path}`,
      method: 'post',
      data
    })
  }

  async update(id: number, data: any): Promise<any> {
    return request({
      url: `/${this.path}/${id}`,
      method: 'put',
      data
    })
  }

  async remove(id?: number): Promise<any> {
    return request({
      url: `/${this.path}/${id}`,
      method: 'delete'
    })
  }
}
